import React, { PropsWithChildren } from 'react'
import { useIntl } from '@babylon/intl'
import { IntlShape } from 'react-intl'

let INTL: IntlShape
type Props = PropsWithChildren<{}>

const IntlGlobalProvider = ({ children }: Props) => {
  const intl = useIntl()
  INTL = intl

  return <>{children}</>
}

const getIntl = () => INTL

export { getIntl }

export default IntlGlobalProvider
